(function($){
        
	// Add Loaded Class
	$('.ptx-relatednav').addClass('ptx-relatednav--loaded');
  
})(jQuery);